<script setup lang="ts">
import { Website } from "@/config";
</script>

<template>
  <div class="app-loader">
    <img src="/images/logo-c-color.svg" class="app-loader__image" width="123" height="150" :alt="Website.name" :title="Website.name" />
  </div>
</template>

<style lang="scss" scoped>
@keyframes loading {
  0% {
    transform: rotateY(0);
  }
  100% {
    transform: rotateY(360deg);
  }
}
.app-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;

  &__image {
    display: block;
    width: 100px;
    max-width: 90%;
    height: auto;
    animation: loading 3s ease-in-out infinite;
    opacity: 0.9;
  }
}
</style>
